<template>
  <div id="chatStatusMsg">
    <div class="workup-launcher-open-icon" >
      <div>
        <div id="chatBody">
          <!-- chat start -->
          <div class="workup-content-wrapper">
            <div class="welcome-msg-wrap">
              <div class="welcome-msg"><span >{{popupMsg}}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const popupMsg = "숏-챗봇이 여러분을 도와드릴게요. 😉";

</script>
<style lang="scss">
.workup-content-wrapper{
  position: relative;
  .welcome-msg-wrap{
    position: absolute;
    right: -66px;
    bottom: 10px;
    .welcome-msg{
      width: max-content;
      max-width: 242px;
      min-height: 52px;
      padding: 16px;
      border-radius: 26px 26px 0px;
      line-height: 1;
      box-shadow: rgba(49, 54, 58, 0.12) 0px 6px 10px 0px;
      background-color: #008fd5;
      box-sizing: border-box;
      word-break: keep-all;
      word-wrap: break-word;
      white-space: pre-line;
      span{
        margin-bottom:0px;
        font-size: 14px;
        line-height: 1.43;
        letter-spacing: -0.42px;
        color: #fff;
        word-break: keep-all;
        white-space: pre-line;
      }
    }
  }
}
</style>
